module.exports = __webpack_public_path__ + "media/img/pages/companies/liechtensteinische_landsbank-d802131dc38f0237eb4e667eed01faaa.jpg";